export const GLOBAL_PIN_CODES_RESET_STATE = 'GLOBAL_PIN_CODES_RESET_STATE';
export const GLOBAL_PIN_CODES_CURRENT_ITEM = 'GLOBAL_PIN_CODES_CURRENT_ITEM';

export const GLOBAL_PIN_CODES_REQUEST_LOADING = 'GLOBAL_PIN_CODES_REQUEST_LOADING';
export const GLOBAL_PIN_CODES_REQUEST_SUCCESS = 'GLOBAL_PIN_CODES_REQUEST_SUCCESS';
export const GLOBAL_PIN_CODES_REQUEST_FAILED = 'GLOBAL_PIN_CODES_REQUEST_FAILED';

export const GLOBAL_PIN_CODES_CURRENT_ACTION = 'GLOBAL_PIN_CODES_CURRENT_ACTION';
export const GLOBAL_PIN_CODES_RESET_ACTION = 'GLOBAL_PIN_CODES_RESET_ACTION';